import React from 'react';
import PropTypes from 'prop-types';
import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer, Legend, Tooltip } from 'recharts';

const CategoryRadarChart = ({ data }) => {
  if (!data || !data.categories || data.categories.length === 0) {
    return (
      <div style={{
        height: 400,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 14,
        color: '#888'
      }}>
        No category data available
      </div>
    );
  }

  // Prepare data for radar chart
  const radarData = data.categories.map((category) => ({
    category: category.categoryName.length > 15 
      ? category.categoryName.substring(0, 15) + '...' 
      : category.categoryName,
    fullCategoryName: category.categoryName,
    score: category.score || 0,
    completionRate: category.totalQuestions > 0
      ? Math.round((category.answeredQuestions / category.totalQuestions) * 100)
      : 0,
  }));

  const renderCustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;
      return (
        <div style={{
          backgroundColor: '#fff',
          border: '1px solid #ddd',
          borderRadius: '4px',
          padding: '10px',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
        }}>
          <p style={{ margin: 0, fontWeight: 'bold', color: '#000' }}>
            {data.fullCategoryName}
          </p>
          <p style={{ margin: '5px 0 0 0', color: '#666' }}>
            Score: {data.score}%
          </p>
          <p style={{ margin: '5px 0 0 0', color: '#666' }}>
            Completion: {data.completionRate}%
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <ResponsiveContainer height={400} width="100%">
      <RadarChart data={radarData} margin={{ top: 20, right: 30, bottom: 20, left: 20 }}>
        <PolarGrid stroke="#e2e8f0" />
        <PolarAngleAxis 
          dataKey="category" 
          tick={{ fontSize: 12, fill: '#475569' }}
          style={{ fontSize: '12px' }}
        />
        <PolarRadiusAxis 
          angle={90} 
          domain={[0, 100]} 
          tick={{ fontSize: 10, fill: '#64748b' }}
        />
        <Radar
          name="Score (%)"
          dataKey="score"
          stroke="#1f7c50"
          fill="#1f7c50"
          fillOpacity={0.3}
          strokeWidth={2}
        />
        <Radar
          name="Completion (%)"
          dataKey="completionRate"
          stroke="#3b82f6"
          fill="#3b82f6"
          fillOpacity={0.2}
          strokeWidth={2}
        />
        <Tooltip content={renderCustomTooltip} />
        <Legend 
          wrapperStyle={{ paddingTop: '20px' }}
          iconType="circle"
        />
      </RadarChart>
    </ResponsiveContainer>
  );
};

CategoryRadarChart.propTypes = {
  data: PropTypes.shape({
    categories: PropTypes.arrayOf(PropTypes.shape({
      categoryName: PropTypes.string.isRequired,
      score: PropTypes.number.isRequired,
      answeredQuestions: PropTypes.number.isRequired,
      totalQuestions: PropTypes.number.isRequired,
    })),
  }).isRequired,
};

export default CategoryRadarChart;

